<template>
  <div class="px-4 sm:px-0 container mx-auto mt-12">
    <section class="content space-y-8 mb-8">
      <div class="text-5xl font-extrabold">
        <span
          class="
            bg-clip-text
            text-transparent
            bg-gradient-to-r
            from-green-400
            to-blue-500
          "
        >
          Карты водителя
        </span>
      </div>

      <div id="digital-driver-cards-widget" class="space-y-4">
        <digital-driver-cards-list class="skzi-view" :cards="cards" />
      </div>

      <digital-driver-cards-necessary-documents />
    </section>
  </div>
</template>

<script>
import DigitalDriverCardsNecessaryDocuments from "@/components/digital-driver-cards/DigitalDriverCardsNecessaryDocuments";
import {getDigitalDriverCards} from "@/api/api";
import DigitalDriverCardsList from "@/components/digital-driver-cards/DigitalDriverCardsList";

export default {
  name: "DigitalDriverCards",
  components: {
    DigitalDriverCardsList,
    DigitalDriverCardsNecessaryDocuments,
  },
  data() {
    return {
      cards: null,
    };
  },
  mounted() {
    getDigitalDriverCards()
    .then(value => {
      this.cards = value.data.filter(card => card.cardType === 'skzi');
    })

  }
};
</script>

<style scoped>
#digital-driver-cards-widget {
  .card-switch-button {
    @apply inline-block px-3 py-1 hover:bg-gray-200;

    &.is-active {
      @apply bg-blue-500 text-white;
    }
    &:first-child {
      @apply rounded-l-md;
    }
    &:last-child {
      @apply rounded-r-md;
    }
  }

  :deep(.tomu-flex-item-width) {
    @screen lg {
      width: 45%;
    }
    @screen xl {
      width: 30%;
    }
  }
}

.tomu-card {
  box-shadow: 0 0 8px 0 #cecece;
}

.tomu-card-content {
  padding: 10px;
}

.tomu-card-controls {
  border: 1px solid #d6d6d6;
  background-color: #e4f5ff;

  .tomu-card-costs {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.tomu-card-title {
  h3 {
    color: dodgerblue;
    text-align: center;
  }
}

.tomu-card-description {
  padding: 15px 15px;
  font-size: 1rem;
}

.tomu-card-image-wrapper {
  text-align: center;

  .tomu-card-image {
    height: auto;
    width: 75%;
  }
}
</style>
